<section class="flex h-screen overflow-hidden">
  @if (mobileNav.isOpen()) {
    <button
      type="button"
      class="fixed inset-0 z-20 bg-black/40 md:hidden"
      aria-label="Fermer le menu"
      (click)="mobileNav.close()"
    ></button>
  }

  <aside
    id="dashboard-mobile-nav"
    class="fixed inset-y-0 left-0 z-30 w-64 max-w-[85vw] overflow-y-auto border-r border-gray-200 bg-white shadow-xl transition-transform duration-200 ease-out md:static md:z-auto md:max-w-none md:shadow-none md:!translate-x-0"
    [class.-translate-x-full]="!mobileNav.isOpen()"
    [class.translate-x-0]="mobileNav.isOpen()"
  >
    <app-sidebar></app-sidebar>
  </aside>

  <section class="flex min-w-0 flex-1 flex-col">
    <div class="z-10 h-16 shrink-0 border-b border-gray-200 bg-white">
      <app-header></app-header>
    </div>
    <div class="relative h-full w-full flex-1 overflow-y-auto bg-gray-50 p-4">
      <router-outlet></router-outlet>
    </div>
  </section>
</section>
